import { render, staticRenderFns } from "./ResumoFiltro.vue?vue&type=template&id=bc3c3f80"
import script from "./ResumoFiltro.vue?vue&type=script&setup=true&lang=js"
export * from "./ResumoFiltro.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports